import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c2badf2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "options" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<svg class=\"d-sm-none\" width=\"21\" height=\"21\" viewBox=\"0 0 66 66\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-0c2badf2><circle cx=\"33.1719\" cy=\"33.4131\" r=\"32.5\" fill=\"#F40000\" data-v-0c2badf2></circle><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M23.0469 30.3403L19.5625 33.8246L30.0156 44.2777L47.4373 26.8559L43.953 23.3716L30.0156 37.309L23.0469 30.3403Z\" fill=\"white\" data-v-0c2badf2></path></svg><svg class=\"d-none d-sm-block\" width=\"66\" height=\"66\" viewBox=\"0 0 66 66\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-0c2badf2><circle cx=\"33.1719\" cy=\"33.4131\" r=\"32.5\" fill=\"#F40000\" data-v-0c2badf2></circle><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M23.0469 30.3403L19.5625 33.8246L30.0156 44.2777L47.4373 26.8559L43.953 23.3716L30.0156 37.309L23.0469 30.3403Z\" fill=\"white\" data-v-0c2badf2></path></svg>", 2)
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<svg class=\"d-none d-sm-block\" width=\"66\" height=\"66\" viewBox=\"0 0 66 66\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-0c2badf2><circle cx=\"33.1719\" cy=\"32.8149\" r=\"30.8921\" fill=\"white\" stroke=\"#F40000\" stroke-width=\"3.21574\" data-v-0c2badf2></circle><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M23.0469 29.7421L19.5625 33.2265L30.0156 43.6795L47.4373 26.2578L43.953 22.7734L30.0156 36.7108L23.0469 29.7421Z\" fill=\"#F40000\" data-v-0c2badf2></path></svg><svg class=\"d-sm-none\" width=\"21\" height=\"21\" viewBox=\"0 0 66 66\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-0c2badf2><circle cx=\"33.1719\" cy=\"32.8149\" r=\"30.8921\" fill=\"white\" stroke=\"#F40000\" stroke-width=\"3.21574\" data-v-0c2badf2></circle><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M23.0469 29.7421L19.5625 33.2265L30.0156 43.6795L47.4373 26.2578L43.953 22.7734L30.0156 36.7108L23.0469 29.7421Z\" fill=\"#F40000\" data-v-0c2badf2></path></svg>", 2)

interface Props {
  options: string[];
  modelValue: number[];
}

interface Emits {
  (event: 'update:model-value', val: number[]): void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    options: null,
    modelValue: null
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'update:model-value', val: number[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  options: string[];
  modelValue: number[];
}




function toggleChecked(index: number) {
  const $value = new Set(props.modelValue);
  if ($value.has(index)) {
    $value.delete(index);
  } else {
    $value.add(index);
  }
  emits('update:model-value', [...$value]);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["item", { active: __props.modelValue.includes(index) }]),
        onClick: ($event: any) => (toggleChecked(index))
      }, [
        _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_3),
        (__props.modelValue.includes(index))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_4
            ], 64))
          : _createCommentVNode("", true),
        (!__props.modelValue.includes(index))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_6
            ], 64))
          : _createCommentVNode("", true)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})